//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Object.js";
import "../no/Preferences.js";
import "../Drawings/Drawings.ViewStyle.js";
let d=[[[0,"CrosshatchPmiLwsv",0,0],[0,"InheritPmiMode",1,0],[0,"InheritPmiToDrawing",1,0],[0,"InheritPmiTypeMask",1,0],[0,"PmiDimensionFromRevolved",1,0]],[[["gdt_option"],"SetInheritGdt",{},1,0],[["crosshatch"],"SetCrosshatchPmiLwsv",{},1,0]],[]];
SPLM.Drawings.InheritPmiViewStyle = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drawings.InheritPmiViewStyle";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;